import CircularProgress from '@material-ui/core/CircularProgress'
import Banner from './Banner'

const useStyles = makeStyles((theme) => ({
  container: (props) => ({
    // position: 'absolute',
    height: '100vh',
    width: '100%',
    paddingTop: '10vh',
    textAlign: 'center',
    fontFamily: ['brother-1816', 'Arial', '"Helvetica Neue"'].join(','),
    backgroundColor: props.light ? 'transparent' : theme.palette.primary.main,
  }),
  image: (props) => ({
    borderRadius: props.circle ? 100 : 0,
  }),
}))

const Loading = ({ show, page, circle, light }) => {
  const classes = useStyles({ show, page, circle, light })

  return (
    <Fade in={show} timeout={300} unmountOnExit>
      <div className={classes.container}>
        <div className={classes.loading}>
          <Banner preTitle="LOADING" noImage light />
          <CircularProgress color={light ? 'primary' : 'secondary'} />
        </div>
      </div>
    </Fade>
  )
}

export default Loading
